import React, { useEffect, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { initMetaPixel } from './utils/metaPixel';
const ForWho = lazy(() => import('./components/ForWho').then(m => ({
  default: m.ForWho
})));
const Benefits = lazy(() => import('./components/Benefits').then(m => ({
  default: m.Benefits
})));
const InstructorTestimonials = lazy(() => import('./components/InstructorTestimonials').then(m => ({
  default: m.InstructorTestimonials
})));
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const ContentOverview = lazy(() => import('./components/ContentOverview').then(m => ({
  default: m.ContentOverview
})));
const PreviewImages = lazy(() => import('./components/PreviewImages').then(m => ({
  default: m.PreviewImages
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const NotForYou = lazy(() => import('./components/NotForYou').then(m => ({
  default: m.NotForYou
})));
const Authority = lazy(() => import('./components/Authority').then(m => ({
  default: m.Authority
})));
const ValueCalculator = lazy(() => import('./components/ValueCalculator').then(m => ({
  default: m.ValueCalculator
})));
const ExitIntentPopup = lazy(() => import('./components/ExitIntentPopup').then(m => ({
  default: m.ExitIntentPopup
})));
export function App() {
  useEffect(() => {
    // Aggressively defer Meta Pixel - only after 5 seconds or user interaction
    if (typeof window !== 'undefined') {
      let pixelLoaded = false;
      const loadPixel = () => {
        if (!pixelLoaded) {
          pixelLoaded = true;
          // Use requestIdleCallback for even lower priority
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => initMetaPixel(), {
              timeout: 2000
            });
          } else {
            setTimeout(initMetaPixel, 100);
          }
        }
      };
      // Load on user interaction or after 5 seconds
      const events = ['scroll', 'click', 'touchstart'];
      events.forEach(event => {
        window.addEventListener(event, loadPixel, {
          once: true,
          passive: true
        });
      });
      const timeout = setTimeout(loadPixel, 5000);
      return () => {
        events.forEach(event => window.removeEventListener(event, loadPixel));
        clearTimeout(timeout);
      };
    }
  }, []);
  return <div className="min-h-screen bg-gradient-dark text-brand-text font-body selection:bg-brand-cta selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />

      <Suspense fallback={null} data-id="element-2">
        <ForWho data-id="element-3" />
        <NotForYou data-id="element-4" />
        <Benefits data-id="element-5" />
        <InstructorTestimonials data-id="element-6" />
        <Authority data-id="element-7" />
        <ComparisonTable data-id="element-8" />
        <ContentOverview data-id="element-9" />
        <PreviewImages data-id="element-10" />
        <Bonuses data-id="element-11" />
        <Pricing data-id="element-12" />
        <FAQ data-id="element-13" />
        <ValueCalculator data-id="element-14" />
        <Footer data-id="element-15" />
      </Suspense>
    </div>;
}